module.exports = __webpack_public_path__ + "img/2.0b5f80cd.gif";